import React, { useEffect, useState } from 'react'
import { postProcedimientoVias } from '../../../services/PaginaRuta'
import ModalModificarCirujanosYCirugiasDQ from './ModalModificarCirujanosYCirugiasDQ'
import ModalEliminarProcedimientoDQx from './ModalEliminarProcedimientoDQx'


const TablaProcedimientoDQX = ({item,passActualizarOtrosParticipantes,dataUser}) => {
  //console.log(item,'DATA IMPORTANTE')
  const [modalOnModificarCirujanosCirugias, setmodalOnModificarCirujanosCirugias]=useState(false)
  const [modalOnEliminarProcedimiento, setmodalOnEliminarProcedimiento]=useState(false)
  const [vias, setvias]=useState('')
  const handleOnclickModificarCirujanos=()=>{
    setmodalOnModificarCirujanosCirugias(true)
  }
  const handleOnClickEliminarProcedimiento=()=>{
    setmodalOnEliminarProcedimiento(true)
  }
  useEffect(()=>{
    
    const via={
      ViaCod:item.ViaCod
    }
    postProcedimientoVias(via).then((res)=>{
      setvias(res.data[0].ViaDsc)
    })
  },[item.ViaCod])
  return (
    <>
      <tr className=" divide-y divide-slate-700">
        <td></td>
        <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
          <button
            onClick={handleOnclickModificarCirujanos}
              type="button"
              className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Modificar
            </button>
          </td>
          <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
          <button
            onClick={handleOnClickEliminarProcedimiento}
              type="button"
              className="inline-block px-3 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Eliminar
            </button>
          </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.CrgCod}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
          {item.CrgDes}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.CrgEst =='S' ? 'Si': 'No'}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap ">
          {item.CrgCnt}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {vias}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.MedCod}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.MedNom}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.EspcCod}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
          {item.EspcDes}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
          {item.CrgHnrCi}
        </td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
          {item.CrgHnCiD}
        </td>
      </tr>
      {modalOnModificarCirujanosCirugias? <ModalModificarCirujanosYCirugiasDQ setmodalOnModificarCirujanosCirugias={setmodalOnModificarCirujanosCirugias} item={item} passActualizarOtrosParticipantes={passActualizarOtrosParticipantes}/>:null}
      {modalOnEliminarProcedimiento? <ModalEliminarProcedimientoDQx setmodalOnEliminarProcedimiento={setmodalOnEliminarProcedimiento} dataUser={dataUser} item={item} passActualizarOtrosParticipantes={passActualizarOtrosParticipantes}/>:null}
    </>
  )
}

export default TablaProcedimientoDQX